// Dati di esempio — da sostituire con i dati reali di SAPORÉ prima della pubblicazione.
export const SITE = {
  name: "SAPORÉ",
  tagline: "La cucina di casa, pronta da portare con te.",
  city: "Lecce",
  address: "Via San Domenico Savio 10, 73100 Lecce (LE)",
  phoneDisplay: "+39 376 296 5925",
  phoneHref: "tel:+393762965925",
  whatsappDisplay: "+39 376 296 5925",
  whatsappNumber: "393762965925",
  email: "info@saporelecce.it",
  piva: "P.IVA 05485950751",
  titolare: "SAPORÈ di Maria Puce",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Via+San+Domenico+Savio+10+Lecce",
  reviewsUrl: "https://www.google.com/maps/search/?api=1&query=SAPOR%C3%89+Via+San+Domenico+Savio+10+Lecce",
  social: {
    facebook: "https://www.facebook.com/share/1LEBTCf9YD/",
    instagram: "https://www.instagram.com/saporelecce/",
  },
  hours: [
    { day: "Lunedì", time: "07:30 – 15:30 · 18:00 – 21:30" },
    { day: "Martedì", time: "07:30 – 15:30 · 18:00 – 21:30" },
    { day: "Mercoledì", time: "07:30 – 15:30 · 18:00 – 21:30" },
    { day: "Giovedì", time: "07:30 – 15:30 · 18:00 – 21:30" },
    { day: "Venerdì", time: "07:30 – 15:30 · 18:00 – 21:30" },
    { day: "Sabato", time: "07:30 – 15:30 · 18:00 – 21:30" },
    { day: "Domenica", time: "10:00 – 13:30 · pomeriggio chiuso" },
  ],
};

const WA_MENU_TEXT = "Buongiorno, vorrei conoscere il menù disponibile oggi e ricevere informazioni per effettuare un ordine da ritirare presso SAPORÉ. Grazie.";
const WA_EVENT_TEXT = "Buongiorno, vorrei ricevere informazioni per un evento.\nData:\nNumero di partecipanti:\nTipologia di evento:\nLuogo:\nRichieste particolari:\n\nResto in attesa di un vostro riscontro. Grazie.";

const WA_QUOTE_TEXT = "Buongiorno, vorrei ricevere informazioni e un preventivo per un evento/buffet SAPORÉ. Grazie.";

export const waLink = (text = WA_MENU_TEXT) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;
export const waMenuLink = waLink(WA_MENU_TEXT);
export const waEventLink = waLink(WA_EVENT_TEXT);
export const waQuoteLink = waLink(WA_QUOTE_TEXT);

const img = (id, w = 1400) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: img("photo-1760445530191-55f1d7a8cfd6", 1600),
  story: img("photo-1447279506476-3faec8071eee"),
  buffet: img("photo-1555244162-803834f70033"),
  chef: img("photo-1665596666171-2378d6e973b9"),
  pasta: img("photo-1514516870926-20598973e480"),
  gallery: [
    { src: img("photo-1660120447916-123439b05c40"), alt: "Tavolata di piatti della tradizione", span: "col-span-2 row-span-2" },
    { src: img("photo-1498579150354-977475b7ea0b"), alt: "Pasta fresca con pomodorini", span: "" },
    { src: img("photo-1662982693758-f69fcb81e7d2"), alt: "Ciotole di specialità mediterranee", span: "" },
    { src: img("photo-1473093295043-cdd812d0e601"), alt: "Primo piatto al pomodoro", span: "" },
    { src: img("photo-1565299624946-b28f40a0ae38"), alt: "Focaccia appena sfornata", span: "" },
    { src: img("photo-1540189549336-e6e99c3679fe"), alt: "Piatto fresco di stagione", span: "row-span-2" },
    { src: img("photo-1481931098730-318b6f776db0"), alt: "Preparazioni del giorno", span: "" },
    { src: img("photo-1509440159596-0249088772ff"), alt: "Focacce e prodotti da forno", span: "col-span-2" },
  ],
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const headerH = document.querySelector("header")?.offsetHeight || 90;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -(headerH + 8) });
  else {
    const y = el.getBoundingClientRect().top + window.scrollY - headerH - 8;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
